import {CurrentProject} from 'common/report/queries/app-api/project-metadata-client';
import {FeatureGate, Permission} from 'common/report/constants';

export function isWarehouseDataAccessible(currentProject: CurrentProject) {
  const warehouseFeatures = currentProject.getFeatureGate(FeatureGate.WarehouseConnectors);

  return (
    currentProject?.hasPermission(Permission.WriteWarehouseSources) &&
    Number.isInteger(warehouseFeatures?.max_number_of_syncs) &&
    warehouseFeatures!.max_number_of_syncs > 0
  );
}
